import { render, staticRenderFns } from "./HiboTabs.vue?vue&type=template&id=37aaaa07&scoped=true&"
import script from "./HiboTabs.vue?vue&type=script&lang=ts&"
export * from "./HiboTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HiboTabs.vue?vue&type=style&index=0&id=37aaaa07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aaaa07",
  null
  
)

export default component.exports